import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({});

export default class A11yReportModel extends Model.extend(Validations) {
  @attr('string') error;
  @attr lastScan;
  @attr('string') report;
  @attr('number') score;
  @attr('number') status;
  @attr('string') url;
  @attr('number') violationsA;
  @attr('number') violationsAA;
  @attr('number') violationsAAA;
  @attr('number') violationsTotal;

  // Relations
  @belongsTo('a11y-scan', { async: true, inverse: null }) scan;

  // Getter and setter
  get displayHeadline() {
    return this.url;
  }

  get displayLabel() {
    return this.url;
  }

  get hasError() {
    return this.error && this.error.length;
  }
}
